import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as date from "../../booking/helpers/date"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { DateTime } from "luxon"
import { trackTravelPlanner, trackTravelPlannerInteraction } from "../../helpers/tracking"

export class ItineraryBoarding extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      airlinesPageLink: props.airlinesPageLink,
      awaitingLabel: props.awaitingLabel,
      closedLabel: props.closedLabel,
      awaitingClosedLabel: props.awaitingClosedLabel,
      gate: props.gate,
      hidePastSteps: props.hidePastSteps,
      showSignupBox: undefined,
      profile: props.profile,
      isLoggedIn: props.isLoggedIn,
      travelInformation: props.travelInformation,
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
    this.handleClickTracking = this.props.handleClickTracking.bind(this)
    this.showSignupModal = this.props.showSignupModal.bind(this)

    this.boardingRef = React.createRef()
  }

  componentDidMount() {
    var hash = window.location.hash
    if (hash) {
      if (hash === "#boarding" || hash === "#new-gate" || hash === "#goto-gate" || hash === "#closing") {
        this.boardingRef.current.scrollIntoView({
          behavior: "smooth",
        })
      }
    }
    if (this.state.profile && Object.keys(this.state.profile).length > 0) {
      this.setState({ isLoggedIn: true }, () => {
        this.showFollowFlightSignupBox()
      })
    } else {
      this.setState({
        showSignupBox: true,
      })
    }
  }

  componentDidUpdate() {
    if (this.state.profile !== this.props.profile) {
      this.setState({ profile: this.props.profile })
    }
    if (this.state.travelInformation !== this.props.travelInformation) {
      this.setState({ travelInformation: this.props.travelInformation }, () => {
        this.showFollowFlightSignupBox()
      })
    }
  }

  showFollowFlightSignupBox() {
    if (this.props.travelInformation && this.props.travelInformation.length > 0) {
      for (let i = 0; i < this.props.travelInformation.length; i++) {
        if (this.props.travelInformation[i].Registration_Source__c === "Follow Flight") {
          this.setState({ showSignupBox: false })
          return
        }
      }
    }
    this.setState({ showSignupBox: true })
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.handleAccordionTracking()
  }

  handleAccordionTracking = () => {
    this.setState({ accordionOpen: !this.state.accordionOpen }, () => {
      if (this.state.accordionOpen) {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_open", { fold_title: this.props.block.heading })
      } else {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_close", { fold_title: this.props.block.heading })
      }
    })
  }

  handleSignUpGateClick = () => {
    this.showSignupModal("gate")
    trackTravelPlanner("track-event.generic", "follow flight - click", "gate", this.state.flightInfo.FlightId)
  }

  handleSignUpStatusClick = () => {
    this.showSignupModal("status")
    trackTravelPlanner("track-event.generic", "follow flight - click", "status", this.state.flightInfo.FlightId)
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const hasContentBlocksBeforeText = this.props.block.contentAreaBeforeText?.length > 0
    const hasContentBlocks = this.props.block.contentArea?.length > 0
    const newLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode
    const hasFocusContentBlocks = this.props.block.focusContentArea?.length > 0

    const dtLocale = date.luxonLocale(this.state.flightInfo.language)
    const zone = "Europe/Copenhagen"
    const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
    const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)

    const signUpLinkGate = (
      <React.Fragment>
        <a className={"pointer"} onClick={this.props.currentPageJson.enableFollowFlight ? () => this.handleSignUpGateClick() : undefined}>
          {this.props.currentPageJson.enableFollowFlight ? this.props.block.boardingSignUpText || "(Tilmeld info)" : ""}
        </a>{" "}
        {this.props.currentPageJson.gateFallbackValue || "Afventer"}
      </React.Fragment>
    )
    // const signUpLinkStatus = <React.Fragment><a className={"pointer"} onClick={this.props.currentPageJson.enableFollowFlight ? () => this.handleSignUpStatusClick() : undefined}>{this.props.currentPageJson.enableFollowFlight ? (this.props.block.boardingSignUpText || "(Tilmeld info)") : ''}</a> {this.props.currentPageJson.statusFallbackValue || "Afventer"}</React.Fragment>

    const gate =
      this.state.flightInfo.Gate && this.state.flightInfo.Gate !== ""
        ? this.state.flightInfo.Gate
        : currentTime < estimatedPublicTime
          ? this.props.awaitingLabel
          : this.props.closedLabel
    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }
    return (
      <div
        ref={this.boardingRef}
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem foldable ${theme ? theme : ""}`}
      >
        <div className={"departure-info__essentials__detailitems__detailitem__header pointer"} onClick={(e) => this.handleAccordionClick(e)}>
          <div className="floatbox">
            <div>{gate}</div>
          </div>
          <h5>{this.props.block.heading}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
        </div>
        {/* as long as we cannot get data this is commented out
                <div className={`departure-info__essentials__detailitems__detailitem__infobox ${infoboxTheme}`}>
                    <div className="grid">
                        <div className="grid-item col--12 col-sm--3">
                            <div className="info-text">{this.props.block.boardingGateLabel}</div>
                            <h5>{this.state.flightInfo.Gate && this.state.flightInfo.Gate !== "" ? this.state.flightInfo.Gate : this.state.awaitingClosedLabel}</h5>
                        </div>
                        <div className="grid-item col--12 col-sm--3">
                            <div className="info-text">{this.props.block.boardingTimeLabel}</div>
                            <h5>{date.formatDate(boardingTime, "LT", this.state.flightInfo.language) ?? this.state.awaitingClosedLabel}</h5>
                        </div>
                        <div className="grid-item col--12 col-sm--3">
                            <div className="info-text">{this.props.block.boardingGateClosesTimeLabel}</div>
                            <h5>{date.formatDate(gateTime, "LT", this.state.flightInfo.language) ?? this.state.awaitingClosedLabel}</h5>
                        </div>
                        <div className="grid-item col--12 col-sm--3">
                            <div className="info-text">{this.props.block.boardingSecurityToGateLabel}</div>
                            <h5>{this.state.gate.walktime ?? this.state.awaitingLabel}</h5>
                        </div>
                    </div>
                </div> */}
        <div className={"contentWrapper show-hide"}>
          <div className={`departure-info__essentials__detailitems__detailitem__infobox`}>
            <div className="grid">
              <div className="grid-item col--12">
                <div className="info-text">{this.props.block.boardingGateLabel}</div>
                <h5 className={this.state.flightInfo.Gate && this.state.flightInfo.Gate !== "" ? "" : "awaiting"}>
                  {this.state.flightInfo.Gate && this.state.flightInfo.Gate !== "" ? this.state.flightInfo.Gate : signUpLinkGate}
                </h5>
              </div>
              <div className="grid-item col--12">
                <div className="info-text">{this.props.block.boardingStatusLabel ?? "Status"}</div>
                <h5>{this.props.publicRemark || this.props.currentPageJson.statusFallbackValue || "Afventer"}</h5>
              </div>
              <div className="grid-item col--12">
                <div className="info-text">
                  {this.props.block.boardingSecurityToGateLabel ?? "Gåafstand"}
                  <br />
                  <div className="grey-text">{this.props.block.boardingSecurityToGateSublabel ?? "(Sikkerhedskontrol til gate)"}</div>
                </div>
                <h5 className={this.state.gate.walktime ? "" : "awaiting"}>
                  {this.state.gate.walktime || this.props.currentPageJson.gateWalktimeFallbackValue}
                </h5>
              </div>
            </div>
          </div>
          {hasContentBlocksBeforeText ? this.renderContentBlocks(this.props.block.contentAreaBeforeText) : ""}
          {this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.linkToAirlineBool ? newLink : this.props.block.buttonLink}
                    onClick={() => this.handleClickTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {(!this.state.flightInfo.Gate && hasFocusContentBlocks) || (!this.state.flightInfo.PublicRemark && hasFocusContentBlocks) ? (
            <div>{this.renderContentBlocks(this.props.block.focusContentArea, this.state.showSignupBox)}</div>
          ) : (
            ""
          )}
          {hasContentBlocks ? this.renderContentBlocks(this.props.block.contentArea) : ""}
        </div>
      </div>
    )
  }
}
